var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "64.000000pt",
    height: "64.000000pt",
    viewBox: "0 0 64.000000 64.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,64.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M525 630 c-11 -5 -86 -75 -167 -157 -146 -146 -148 -149 -167 -218 -11 -39 -16 -74 -12 -78 4 -4 41 1 82 12 l74 21 153 154 c167 169 174 182 125 235 -32 34 -59 43 -88 31z m75 -62 c13 -25 13 -29 -3 -45 -16 -17 -19 -16 -53 19 -41 41 -38 61 9 56 22 -2 36 -11 47 -30z m-80 -53 l34 -35 -114 -115 -114 -115 -38 37 -38 37 112 113 c62 62 115 113 118 113 4 0 21 -16 40 -35z m-242 -286 c-7 -3 -25 -9 -39 -13 -27 -6 -27 -6 -17 35 l11 40 29 -27 c20 -20 25 -30 16 -35z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63 573 c-13 -2 -32 -16 -43 -30 -19 -24 -20 -40 -20 -249 0 -237 4 -264 47 -283 15 -7 109 -11 263 -11 238 0 239 0 267 24 26 23 28 30 32 111 2 57 -1 91 -8 98 -21 21 -31 -13 -31 -100 0 -71 -3 -84 -19 -93 -12 -6 -110 -10 -250 -10 -218 0 -232 1 -251 20 -19 19 -20 33 -20 236 0 129 4 223 10 235 9 16 22 19 90 19 93 0 116 6 99 26 -11 14 -111 18 -166 7z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.047255d9ba6d18490d2647185478927d.svg";
export { ForwardRef as ReactComponent };